import { useState } from "react";
import { COMMON_FIELD_TYPES } from "../constants/fieldTypes";
import { validateField } from "../utils/validationUtils";
import { errorMessages } from "../constants/frontendErrorMessages"

const useForm = (initialValues = {}, requiredFields = {}, inputTypes = {}) => {
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouchedState] = useState({});

  const handleInputChange = (name, value) => {
    let updatedValue = value;

    console.log("Before Update:", name, value);

    // Handle dropdown selections
    if (
        inputTypes[name]?.type === COMMON_FIELD_TYPES.DROPDOWN &&
        typeof value === "object"
    ) {
      updatedValue = value?.[inputTypes[name].displayKey] || "";
    }

    setFormData((prev) => {
      const newFormData = { ...prev, [name]: updatedValue };

      console.log('newFormData', newFormData);

      // Validate using updated formData
      const error = validateField(
          name,
          inputTypes[name],
          typeof updatedValue === "string" ? updatedValue?.trim() : updatedValue,
          newFormData,
          requiredFields
      );

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));

      return newFormData;
    });
  };

  const handleBlur = (name, value) => {
    // console.log("On Blur:", name, value);

    let sanitizedValue = typeof value === "boolean" ? value : value?.trim() || value;

    // Sanitizing the date input
    if (inputTypes[name] === COMMON_FIELD_TYPES.DATE_PICKER) {
      // console.log(sanitizedValue);
      sanitizedValue = sanitizedValue ? new Date(sanitizedValue)?.toISOString()?.split("T")[0] : "";
      // console.log(sanitizedValue);

    }

    // Sanitizing the time input
    if (inputTypes[name] === COMMON_FIELD_TYPES.TIME_PICKER && sanitizedValue) {
      // Ensure the time is in the correct format: 'hh:mm AM/PM'
      const [hourMinute, period] = sanitizedValue.split(" ");

      if (hourMinute && period) {
        const [hour, minute] = hourMinute.split(":");
        const sanitizedHour = hour?.padStart(2, "0");
        const sanitizedMinute = minute?.padStart(2, "0");
        sanitizedValue = `${sanitizedHour}:${sanitizedMinute} ${period.toUpperCase()}`;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));

    setTouchedState((prev) => ({
      ...prev,
      [name]: true,
    }));

    // Validate the field on blur
    let error = validateField(
        name,
        inputTypes[name],
        sanitizedValue,
        formData,
        requiredFields
    );

    // if (name === "terms" && requiredFields[name] && value !== true) {
    //   error = errorMessages.REQUIRED_FIELD;
    // }

    // console.log("error", error);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // Function to clear errors on focus
  const clearError = (name) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Function to clear all errors on focus at once
  const clearAllErrors = () => {
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {

      newErrors[key] = validateField(
          key,
          inputTypes[key],
          typeof formData[key] === "string" ? formData[key]?.trim() : formData[key],
          formData,
          requiredFields
      );

      // if (key === "terms" && requiredFields[key] && formData[key] !== true) {
      //   newErrors[key] = errorMessages.REQUIRED_FIELD;
      // }

    });

    // console.log(newErrors);

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  return {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    clearError,
    validateForm,
    setTouched: setTouchedState,
    setErrors,
    clearAllErrors,
    setFormData,
  };
};

export default useForm;